<template>
    <div class="login-container">
        
    </div>
</template>

<script>
export default {
    name:'appLogin',
    data(){
        return {
            
        }
    },
    computed:{
        isUser() {
            return this.$store.state.Login.isUser;
        },
        loginDialog(){
            return this.$store.state.Login.loginDialog
        }
    },
    watch:{
        isUser(val){
            if(val){
                let data = {
                    type:'login',
                    data:localStorage.getItem('userInfo'),
                }
                uni.postMessage({
                    data:data
                })
            }
        },
        loginDialog:{
            deep:true,
            handler(val){
                if(uni && uni.postMessage){
                    let data = {
                        type:'loginDialog',
                        data:val,
                    }
                    uni.postMessage({
                        data:data
                    })
                }
            }
        }
    },
    created(){ 
        this.$store.commit("Login/editIsUser",false)
        sessionStorage.setItem('isApp',true)
        this.goLogin()
        
        this.loadScript(`https://static.hqwx.com/uni/webview.js?v=20200701`,()=>{})
     
    },
    methods:{   
        getEnv(){

        }
    }
}
</script>
<style>
.van-overlay{
    background: none;
}
body{
    background: none;
}
.text-r{
    display: none1;
}
</style>